import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ProfileOptions() {
  const navigate = useNavigate();
  const [showVerifyModal, setShowVerifyModal] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    try { window.dispatchEvent(new CustomEvent('user-changed')); } catch(e){}
    navigate('/signin');
  }

  const handleDelete = () => {
    if (!window.confirm('Delete your account and all data permanently? This cannot be undone.')) return;
    fetch('/user/delete', { method: 'DELETE', headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') } })
      .then(r => r.json())
      .then(resp => {
        if (resp && resp.ok) {
          localStorage.clear();
          try { window.dispatchEvent(new CustomEvent('user-changed')); } catch(e){}
          navigate('/signup');
        } else {
          alert((resp && resp.error) ? resp.error : 'Unable to delete account');
        }
      }).catch(err => { console.error(err); alert('Delete failed'); });
  }

  return (
    <div style={{padding:16}}>
      <div style={{display:'flex', alignItems:'center', gap:8}}>
        <button onClick={() => navigate(-1)} style={{border:'none', background:'transparent', cursor:'pointer', fontSize:24}}>←</button>
        <h2 style={{margin:0}}>Options</h2>
      </div>

      <div style={{marginTop:20, display:'flex', flexDirection:'column', gap:12}}>
        <button onClick={() => setShowVerifyModal(true)} style={{padding:12, background:'#363636', color:'#fff', border:'none', borderRadius:8, fontSize:16}}>✅ Linkalikes Verification</button>
        <button onClick={() => navigate('/profile/creator')} style={{padding:12, background:'#363636', color:'#fff', border:'none', borderRadius:8, fontSize:16}}>Creator of Linkalikes</button>
        <button onClick={handleLogout} style={{padding:12, background:'#8a8ad6', color:'black', border:'none', borderRadius:8, fontSize:16}}>Log Out</button>
        <button onClick={handleDelete} style={{padding:12, background:'red', color:'white', border:'1px solid #ff4458', borderRadius:8, fontSize:16, fontWeight:"700"}}>Delete Account</button>
      </div>

      {showVerifyModal && (
        <div style={{position:'fixed',left:0,top:0,right:0,bottom:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:3000}} onClick={() => setShowVerifyModal(false)}>
          <div onClick={(e)=>e.stopPropagation()} style={{background:'var(--surface)',color:'var(--text)',padding:20,borderRadius:8,maxWidth:520,width:'90%',position:'relative'}}>
            <button aria-label="Close" onClick={() => setShowVerifyModal(false)} style={{position:'absolute',top:8,right:8,border:'none',background:'transparent',fontSize:20,cursor:'pointer'}}>✕</button>
            <div style={{display:'flex',justifyContent:'flex-start',alignItems:'center',gap:12}}>
              <h3 style={{margin:0}}>✅ Linkalikes Verification</h3>
            </div>
            <div style={{marginTop:12,whiteSpace:'pre-wrap',lineHeight:1.5}}>
              <p style={{margin:0}}>Please send an email to <a href="mailto:linkalikes.verify@gmail.com?subject=Verify%20my%20account" style={{color:'#2c7be5'}}>linkalikes.verify@gmail.com</a> with Subject: "Verify my account" from the email address that you've signed in with in the Linkalikes app.</p>
              <div style={{display:"flex", justifyContent:"left", marginTop:12,fontWeight:700}}>Things to be included in the email:</div>
              <ol style={{marginTop:8,paddingLeft:18}}>
                <li style={{display:"flex", justifyContent:"left"}}>1) Linkalikes account username</li>
              </ol>
              <div style={{color:"yellowgreen", display:"flex", justifyContent:"center", fontWeight:"700"}}>We'll respond to your email within 24 hours.</div>
            </div>
            {/* no bottom close button per request; modal closed via top-right X or outside click */}
          </div>
        </div>
      )}
    </div>
  );
}
